/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemDependencyStateSchema } from './itemDependencyStateSchema';
import { itemHealthRiskSchema } from './itemHealthRiskSchema';

export const itemHealthResponseSchema = z.object({
  aggregatedActualSeconds: z.int().describe('Aggregated actual seconds for self and descendants'),
  aggregatedPlanSeconds: z.int().describe('Aggregated plan seconds for self or descendants'),
  get dependency() {
    return itemDependencyStateSchema.describe('Dependency state and predecessor-level causes');
  },
  healthLevel: z
    .enum(['HEALTHY', 'NEEDS_ATTENTION', 'ACTION_REQUIRED', 'DONE'])
    .describe('Health level of the item based on its data and detected risks'),
  itemId: z.int().describe('Item id'),
  percentageDiff: z
    .number()
    .describe(
      'Remaining percentage against aggregated actual effort; positive means under plan, negative means over plan',
    )
    .nullish(),
  progress: z.int().describe('Progress percentage'),
  get risks() {
    return z.array(itemHealthRiskSchema).describe('Detected risks associated with the item');
  },
});
